export var GraphqlQueryName;

(function (GraphqlQueryName) {
  GraphqlQueryName["digitalPlatformHeader"] = "digitalPlatformHeader";
  GraphqlQueryName["digitalPlatformFooter"] = "digitalPlatformFooter";
})(GraphqlQueryName || (GraphqlQueryName = {}));

export var NavigationDataType;

(function (NavigationDataType) {
  NavigationDataType["SignedOutHeader"] = "SignedOutHeader";
  NavigationDataType["SignedInHeader"] = "SignedInHeader";
  NavigationDataType["SignedInFooter"] = "SignedInFooter";
  NavigationDataType["SignedOutFooter"] = "SignedOutFooter";
  NavigationDataType["LanguageSelector"] = "LanguageSelector";
  NavigationDataType["FooterLegal"] = "FooterLegal";
  NavigationDataType["SignedOutNavigation"] = "SignedOutHeader,SignedOutFooter";
  NavigationDataType["AuthPageSignedOutNavigation"] = "SignedOutHeader,FooterLegal";
})(NavigationDataType || (NavigationDataType = {}));

export var FOOTER = 'Footer';
export var locales;

(function (locales) {
  locales["es-419"] = "es-419";
  locales["es"] = "es";
  locales["en"] = "en";
  locales["ko"] = "ko";
  locales["tr"] = "tr";
  locales["es-US"] = "es-US";
  locales["en-US"] = "en-US";
})(locales || (locales = {}));

export var geoCountryCode;

(function (geoCountryCode) {
  geoCountryCode["US"] = "US";
  geoCountryCode["intl"] = "intl";
})(geoCountryCode || (geoCountryCode = {}));